// @flow

import React from 'react';

import type {AttachedChoiceType} from 'app/general/types';

import {StyledStepContentSeparatorDiv, StepDecisionTitle} from './structures';
import {gt} from 'app/utils/i18n';
import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {ChoiceDestination} from 'app/tasks/components/ProcedureTaskPage/CheckableChoices';
import type {AnyStepType} from 'app/steps/types';

type Props = {|
  choices?: Array<AttachedChoiceType>,
  steps: Array<AnyStepType>,
  edit: boolean,
  onClick?: (SyntheticMouseEvent<any>) => any,
|};

export class ViewableChoices extends React.PureComponent<Props> {
  render() {
    const {choices, steps, edit, ...other} = this.props;
    return choices != null && choices.length > 0 ? (
      <StyledStepContentSeparatorDiv className="choices">
        <StepDecisionTitle />
        <ul className="list-group">
          {choices.map((choice) => {
            const LiNode = (
              <ChoiceDestination
                isChecked={false}
                key={choice.id}
                choice={choice}
                steps={steps}
                disabled={edit}
                userIndicator={null}
                {...other}
              />
            );

            if (edit) {
              return LiNode;
            } else {
              return (
                <LazyTooltip
                  key={choice.id}
                  placement="top"
                  tooltip={gt(
                    'Start this procedure to begin checking off steps.'
                  )}
                >
                  {LiNode}
                </LazyTooltip>
              );
            }
          })}
        </ul>
      </StyledStepContentSeparatorDiv>
    ) : null;
  }
}
